import React from 'react';
import { FlexCol, FlexRow } from '../../../../common/components/v2';
import styles from '../../styles.module.scss';

export const Remarks = ({
  sufficient = true,
  feedback = '',
}: {
  sufficient?: boolean;
  feedback?: string;
}) => {
  return (
    <>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          Remarks
        </FlexCol>
        <FlexCol sm={6} className={styles.TaskInfoCell}>
          {sufficient ? 'Sufficient' : 'Insufficent'}
        </FlexCol>
      </FlexRow>
      {feedback && feedback.length > 0 && (
        <FlexRow className={styles.MarginTop}>
          <FlexCol sm={3} className={styles.TaskLeftCell}>
            Desciption
          </FlexCol>
          <FlexCol sm={6} className={styles.TaskInfoCell}>
            {feedback}
          </FlexCol>
        </FlexRow>
      )}
    </>
  );
};
